import { render } from "./rtl.vue?vue&type=template&id=14864a12"
import script from "./rtl.vue?vue&type=script&lang=js"
export * from "./rtl.vue?vue&type=script&lang=js"

import "./rtl.vue?vue&type=style&index=0&id=14864a12&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__